import { F0Select } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface SelectTimeSlotProps {
  onChange: (value: string) => void
  value: string
  label: string
  error?: string
}

export const SelectTimeSlot = ({ onChange, value, label, error }: SelectTimeSlotProps) => {
  return (
    <F0Select
      label={label}
      onChange={onChange}
      options={[
        {
          label: i18n.t('meetings.create_scheduled_meeting.duration_options.15'),
          value: '15',
        },
        {
          label: i18n.t('meetings.create_scheduled_meeting.duration_options.30'),
          value: '30',
        },
        {
          label: i18n.t('meetings.create_scheduled_meeting.duration_options.45'),
          value: '45',
        },
        {
          label: i18n.t('meetings.create_scheduled_meeting.duration_options.60'),
          value: '60',
        },
        {
          label: i18n.t('meetings.create_scheduled_meeting.duration_options.90'),
          value: '90',
        },
      ]}
      placeholder={i18n.t('meetings.create_scheduled_meeting.duration_placeholder')}
      value={value}
      error={error}
      size="md"
    />
  )
}
